import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { ChatbotService } from '#core/services/chatbot.service';
import { SvgIcon } from '#shared/modules/svg-icon.enum';

@Component({
    selector: 'app-chatbot-button',
    standalone: true,
    imports: [MatIconModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './chatbot-button.component.html',
})
export class ChatbotButtonComponent {
    private readonly _chatbotService = inject(ChatbotService);

    protected readonly SvgIcon = SvgIcon;

    readonly isLauncherDisplayable = this._chatbotService.isLauncherDisplayable;

    onNeedHelpButtonClick(): void {
        this._chatbotService.show();
    }
}
